$(() => {
  $('.js-tab a').click(e => {
    $(e.currentTarget).tab('show');
    return false;
  });
});
